export enum InputTypeEnum {
  Text = 'text',
  Number = 'number',
  Decimal = 'decimal',
  TimePicker = 'timePicker',
  Calendar = 'calendar',
  Dropdown = 'dropdown',
  Checkbox = 'checkbox',
  Switch = 'switch',
  Radio = 'radio',
  TextArea = 'textArea',
  Password = 'password',
  Phone = 'phone'
}